import { createContext, useContext, useState, useEffect } from "react";
import { getUserClaims } from "./AuthService";
import { loadFromStorage } from "../../utils";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({children}) => {
    const [userClaims, setUserClaims] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const refreshAuthState = async () => {
        try {
            const claims = await getUserClaims();
            if (claims) {
                setUserClaims(claims);
                setIsAuthenticated(true);
            } else {
                setUserClaims(null);
                setIsAuthenticated(false);
            }
        } catch(e) {
            console.error("Error al verificar la sesión: ", e);
            setIsAuthenticated(false);
        } finally {
            setIsLoading(false);
        }
        
    }

    useEffect(() => {
        refreshAuthState();
    }, []);

    const value = {
        userClaims, isAuthenticated, isLoading, refreshAuthState
    }

    //Check the expiration time for every local key.
    useEffect (() => {
        const keys = ['SESSION_DATA', 'FORECAST_FILTERS', 'JOBTRACK_FILTERS', 'MRP_FILTERS', 
            'PLANT_RECORD_FILTERS', 'PROCESS_FILTERS', 'SELECTED_BUDGET']

        keys.forEach(key => {
            loadFromStorage(key);
        })
    }, []);

    // useEffect(() => {
    //     console.log("Estado actualizado: ", {userClaims, isAuthenticated})
    // }, [userClaims, isAuthenticated]) 

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}